const Footer = () => {
  
  return (
    <a href="https://assurewealth.co.th/" target="_blank" rel="noopener noreferrer" className="w-full group">
      <div className="md:shadow-xl shadowfooter bg-white flex justify-center items-center gap-[11px] py-3 w-full cursor-pointer group-hover:opacity-80 transition-opacity">
        <img src="/images/logo_assure.png" className="h-5" alt="Assure Wealth Logo" />
        <div className="text-mainblue text-[10px] font-normal flex-none">
          สงวนลิขสิทธิ โดย บริษัท แอสชัว เวลธ์ จำกัด
        </div>
      </div>
    </a>
  );
};

export default Footer;
